import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import { Send } from "lucide-react";
import { STATEMENT_PRESETS as PRESET_TEMPLATES } from "./utils";

export function SendStatementModal({
  open,
  onOpenChange,
  ownerEmail,
  stmtNote,
  setStmtNote,
  customTemplates,
  onSaveTemplate,
  onSubmit,
  busy,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="send-stmt-modal">
        <DialogHeader><DialogTitle>Send overdue statement</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="text-xs text-muted-foreground">Emails the branded PDF to <span className="font-medium text-foreground">{ownerEmail || "—"}</span>. Add a short personal note below (optional) and it'll appear as a callout inside the email.</p>
          <div>
            <Label>Quick templates</Label>
            <div className="flex flex-wrap gap-1 mt-1" data-testid="stmt-template-chips">
              {PRESET_TEMPLATES.map((t) => (
                <button key={t} type="button" onClick={() => setStmtNote(t)}
                        className="text-[11px] rounded-full border border-border px-3 py-1 hover:border-primary/60 hover:bg-primary/5 transition-colors"
                        data-testid={`tpl-preset-${t.slice(0, 12)}`}>
                  {t.slice(0, 40)}{t.length > 40 ? "…" : ""}
                </button>
              ))}
              {customTemplates.map((t) => (
                <button key={t} type="button" onClick={() => setStmtNote(t)}
                        className="text-[11px] rounded-full border border-primary/40 bg-primary/5 text-primary px-3 py-1 hover:bg-primary/10 transition-colors"
                        data-testid={`tpl-custom-${customTemplates.indexOf(t)}`}
                        title="Custom template (saved locally)">
                  {t.slice(0, 40)}{t.length > 40 ? "…" : ""}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label htmlFor="stmt-note">Personal note <span className="text-muted-foreground font-normal text-[11px]">(optional)</span></Label>
              <button type="button" onClick={onSaveTemplate}
                      disabled={!stmtNote.trim() || customTemplates.includes(stmtNote.trim())}
                      className="text-[11px] text-primary hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
                      data-testid="tpl-save-btn">
                Save as template
              </button>
            </div>
            <textarea id="stmt-note" rows={4} value={stmtNote}
                      onChange={(e) => setStmtNote(e.target.value)}
                      placeholder="e.g. Hi Anita, please clear this by 25th so we can close the books this quarter."
                      className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring resize-none"
                      data-testid="stmt-note-input" />
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button type="button" onClick={onSubmit} disabled={busy} data-testid="stmt-send-btn">
            <Send size={14} className="mr-2" />{busy ? "Sending…" : "Send email"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
